import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Carlos Mendoza',
  project: 'Full Remodel',
  text: 'Hiring WC Home Remodeling was the best decision. Their 20+ years of experience shows in every detail. Wilson handled all permits seamlessly and finished on time.',
  rating: 5
}, {
  name: 'Laura Taylor',
  project: 'Kitchen Renovation',
  text: 'They transformed my outdated kitchen into the space of my dreams. The team was very respectful, clean, and always kept me informed of daily progress.',
  rating: 5
}, {
  name: 'The Rodriguez Family',
  project: 'Second Floor Addition',
  text: 'A complex project they handled with total professionalism. The constant supervision gave us great peace of mind. The result exceeded our expectations.',
  rating: 5
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-light" data-id="element-260">
      <div className="container mx-auto px-6 md:px-12" data-id="element-261">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-262">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-263">
            <h2 className="text-accent font-medium tracking-widest uppercase text-sm mb-3" data-id="element-264">
              What Our Clients Say
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-6" data-id="element-265">
              Satisfaction Guaranteed
            </h3>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-266">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-sm shadow-sm relative" data-id="element-267">
              <Quote className="absolute top-6 right-6 text-light-alt" size={48} data-id="element-268" />

              <div className="flex gap-1 mb-6" data-id="element-269">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} size={18} className="text-accent" fill="currentColor" data-id="element-270" />)}
              </div>

              <p className="text-gray-600 italic mb-8 relative z-10 leading-relaxed" data-id="element-271">
                "{testimonial.text}"
              </p>

              <div data-id="element-272">
                <h4 className="font-serif font-bold text-primary text-lg" data-id="element-273">
                  {testimonial.name}
                </h4>
                <p className="text-sm text-accent font-medium" data-id="element-274">
                  {testimonial.project}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}